import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

export const getMaxInstallment = (data: maxInstallment) => {
  const offer = data?.product?.skus?.[0]?.offers?.result?.[0];
  return offer?.cartaoVisa?.maxQuantity?.[0]?.quantity ?? 1;
};

export const toggleTheftSelected = (
  setTheftSelected: React.Dispatch<React.SetStateAction<boolean>>,
  dispatchMetrics: DispatchMetrics,
  productWasNotSelected: boolean,
  setProductWasNotSelected: React.Dispatch<React.SetStateAction<boolean>>
) => () => {
  if (productWasNotSelected) {
    dispatchMetrics('event:track', {
      event: 'c:click',
      category: 'pdp-produtos-adjacente',
      action: 'adicionar-produto',
      label: 'seguro-roubo-furto',
    });
    setProductWasNotSelected(false);
  }

  setTheftSelected(inverseValue);
};

export const inverseValue = (previusValue: boolean) => !previusValue;

export const formatServiceTheft = (services: services, history: history, dispatchMetrics: DispatchMetrics) => {
  const arrayServices = services?.[0]?.services;
  const serviceTheft = arrayServices?.filter(getServiceTheft)?.[0];
  const nameOfService = serviceTheft?.name;
  const price = serviceTheft?.options?.[1]?.installmentText;
  const numberOfInstallments = serviceTheft?.options?.[1]?.installmentQty;
  const coverageTime = serviceTheft?.options?.[1]?.optionId?.replace('_', ' ').toLowerCase();

  return {
    price,
    coverageTime,
    nameOfService,
    numberOfInstallments,
    showRobberyAndTheftInsurance: showRobberyAndTheftInsurance(dispatchMetrics),
    showCoverage: showCoverage(history),
    showHiringPolicy: showHiringPolicy(history),
  };
};

export const showRobberyAndTheftInsurance = (dispatchMetrics: DispatchMetrics) => () => {
  const link = 'https://www.mapfre.com.br/para-voce/outros-seguros/equipamentos-eletronicos/';

  dispatchMetrics('modal:open', {
    id: 'termo-cobertura-seguro',
  });

  try {
    window.open(link, '_blank');
  } catch (e) {
    console.error(e);
  }
};

export const showCoverage = (history: history) => replaceUrlParams(history, '#modal-service-theft-coverage', false);

export const showHiringPolicy = (history: history) =>
  replaceUrlParams(history, '#modal-hiring-policy-service-theft', false);

export const hasServiceTheft = (data: hasServiceTheftProps): boolean => {
  const services = data?.product?.skus?.[0]?.offers?.result?.[0]?.productServices?.[0]?.services;
  return services?.some(getServiceTheft);
};

export const getInfoForWarranty = (formattedServices: formattedServices, isTheftSelected: boolean) => {
  if (isTheftSelected) {
    const serviceTheft = formattedServices?.[0]?.services?.filter(getServiceTheft);

    return {
      id: serviceTheft?.[0].id,
      optionId: serviceTheft?.[0]?.options?.[1]?.optionId,
      productSku: formattedServices?.[0]?.sku?.id,
    };
  }

  return null;
};

export const getServiceTheft = (service: service): boolean => service?.id === 'ROUBO_FURTO';

export type DispatchMetrics = (event: string, body: any) => void;

export type withServicePDP = (
  Component: React.FC<withServicesPDPReturn>
) => (props: withServicesPDPProps) => JSX.Element;

export interface servicesPDP {
  infoForComponent: infoForComponent;
  infoForWarranty: infoForWarranty | null;
}

export interface infoForComponent {
  price: string;
  coverageTime: string;
  nameOfService: string;
  isTheftSelected: boolean;
  numberOfInstallments: number;
  showRobberyAndTheftInsurance: () => void;
  showHiringPolicy: () => void;
  showCoverage: () => void;
  toggleTheftSelected: () => void;
}

export interface infoForWarranty {
  id: string;
  optionId: string;
  productSku: string;
}

export interface withServicesPDPReturn {
  servicesPDP: servicesPDP | null;
}

export interface maxInstallment {
  product: {
    skus: [
      {
        offers: {
          result: [
            {
              cartaoVisa: {
                maxQuantity: [{ quantity: number }];
              };
            }
          ];
        };
      }
    ];
  };
}

export interface hasServiceTheftProps {
  product: product;
}

export interface withServicesPDPProps {
  id: number;
  currentSku: {
    id: number;
  };
  product: product;
  history: history;
  dispatchMetrics: DispatchMetrics;
}

export type product = {
  skus: [
    {
      offers: {
        result: [
          {
            seller: {
              id: number;
            };
            productServices: [{ services: service[] }];
          }
        ];
      };
    }
  ];
};

export type formattedServices = [
  {
    services: service[];
    sku: {
      id: string;
    };
  }
];

export type services = [
  {
    services: service[];
  }
];

export type service = {
  id: string;
  name: string;
  options: optionOfService[];
};

export type optionOfService = {
  installmentText: string;
  installmentQty: number;
  optionId: string;
};

export type history = {
  push: (value: string) => void;
  location: {
    search: string;
  };
};
